import { useState } from "react";

import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import SEO from "../../components/SEO";

export default function AgeCalculator() {

  const [dob, setDob] =
    useState("");

  const [result, setResult] =
    useState(null);

  const [error, setError] =
    useState("");

  const calculateAge = () => {

    setError("");

    if (!dob) {

      setResult(null);

      setError(
        "Please select your date of birth"
      );

      return;
    }

    const birthDate =
      new Date(dob);

    const today =
      new Date();

    if (birthDate > today) {

      setResult(null);

      setError(
        "Future date is not allowed"
      );

      return;
    }

    let years =
      today.getFullYear() -
      birthDate.getFullYear();

    let months =
      today.getMonth() -
      birthDate.getMonth();

    let days =
      today.getDate() -
      birthDate.getDate();

    if (days < 0) {

      months--;

      const prevMonth =
        new Date(
          today.getFullYear(),
          today.getMonth(),
          0
        ).getDate();

      days += prevMonth;
    }

    if (months < 0) {

      years--;

      months += 12;
    }

    const totalDays =
      Math.floor(
        (
          today - birthDate
        ) /
        (
          1000 * 60 * 60 * 24
        )
      );

    const totalWeeks =
      Math.floor(
        totalDays / 7
      );

    const totalHours =
      totalDays * 24;

    /* NEXT BIRTHDAY */

    let nextBirthday =
      new Date(
        today.getFullYear(),
        birthDate.getMonth(),
        birthDate.getDate()
      );

    if (
      nextBirthday < today
    ) {

      nextBirthday.setFullYear(
        today.getFullYear() + 1
      );
    }

    const birthdayDiff =
      nextBirthday - today;

    const daysLeft =
      Math.ceil(
        birthdayDiff /
        (
          1000 * 60 * 60 * 24
        )
      );

    setResult({
      years,
      months,
      days,
      totalDays,
      totalWeeks,
      totalHours,
      daysLeft,
    });
  };

  return (
    <>
      <SEO
        title="Free Age Calculator Online"
        description="Calculate your exact age in years, months, days, weeks, and hours instantly using our free online age calculator."
        keywords="age calculator, exact age calculator, date of birth calculator, birthday calculator"
        url="https://online-tools-center.vercel.app/age-calculator"
      />

      <Navbar />

      <div className="container py-4">

        <div className="row justify-content-center">

          <div className="col-lg-9">

            <div className="card shadow-lg border-0 rounded-4 p-4">

              {/* HERO */}

              <div className="text-center mb-4">

                <h1 className="fw-bold mb-3">
                  Age Calculator
                </h1>

                <p className="text-muted">
                  Calculate your exact age
                  in years, months, days,
                  weeks, and hours instantly.
                </p>

                <div className="d-flex flex-wrap justify-content-center gap-2 mt-3">

                  <span className="badge bg-light text-dark p-2">
                    ✓ Exact Age
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Birthday Countdown
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Free Tool
                  </span>

                  <span className="badge bg-light text-dark p-2">
                    ✓ Mobile Friendly
                  </span>

                </div>

              </div>

              {/* INPUT */}

              <div className="row g-4 align-items-center">

                <div className="col-md-6">

                  <label className="fw-semibold mb-2">
                    Select Date of Birth
                  </label>

                  <input
                    type="date"
                    className="form-control mb-3"
                    value={dob}
                    onChange={(e) =>
                      setDob(
                        e.target.value
                      )
                    }
                  />

                  <button
                    className="btn btn-primary w-100 py-2 fw-semibold"
                    onClick={calculateAge}
                  >
                    Calculate Age
                  </button>

                  {error && (

                    <div className="alert alert-danger mt-3">

                      {error}

                    </div>

                  )}

                </div>

                {/* RIGHT SIDE */}

                <div className="col-md-6">

                  <div className="bg-light rounded-4 p-4">

                    <h4 className="fw-bold mb-3">
                      Features
                    </h4>

                    <ul className="mb-0">

                      <li>
                        Exact age calculation
                      </li>

                      <li>
                        Years, months & days
                      </li>

                      <li>
                        Birthday countdown
                      </li>

                      <li>
                        Total days & hours
                      </li>

                      <li>
                        Mobile responsive
                      </li>

                    </ul>

                  </div>

                </div>

              </div>

              {/* RESULTS */}

              {result && (

                <div className="mt-5">

                  <div className="row g-4">

                    <div className="col-md-4">

                      <div className="card border-0 shadow-sm rounded-4 p-4 text-center">

                        <h5>
                          Exact Age
                        </h5>

                        <h3 className="fw-bold">

                          {result.years}
                          y{" "}

                          {result.months}
                          m{" "}

                          {result.days}
                          d

                        </h3>

                      </div>

                    </div>

                    <div className="col-md-4">

                      <div className="card border-0 shadow-sm rounded-4 p-4 text-center">

                        <h5>
                          Total Days
                        </h5>

                        <h3 className="fw-bold">

                          {result.totalDays.toLocaleString()}

                        </h3>

                      </div>

                    </div>

                    <div className="col-md-4">

                      <div className="card border-0 shadow-sm rounded-4 p-4 text-center">

                        <h5>
                          Next Birthday
                        </h5>

                        <h3 className="fw-bold">

                          {result.daysLeft}
                          {" "}
                          days left

                        </h3>

                      </div>

                    </div>

                  </div>

                  {/* EXTRA STATS */}

                  <div className="row g-4 mt-2">

                    <div className="col-md-6">

                      <div className="card border-0 bg-light rounded-4 p-4 text-center">

                        <h5>
                          Total Weeks
                        </h5>

                        <h3 className="fw-bold">

                          {result.totalWeeks.toLocaleString()}

                        </h3>

                      </div>

                    </div>

                    <div className="col-md-6">

                      <div className="card border-0 bg-light rounded-4 p-4 text-center">

                        <h5>
                          Total Hours
                        </h5>

                        <h3 className="fw-bold">

                          {result.totalHours.toLocaleString()}

                        </h3>

                      </div>

                    </div>

                  </div>

                </div>

              )}

            </div>

            {/* SEO CONTENT */}

            <div className="mt-5">

              <h2 className="fw-bold mb-3">
                What is an Age Calculator?
              </h2>

              <p>
                An age calculator helps users
                calculate exact age based on
                date of birth. It provides
                age in years, months, days,
                weeks, and hours instantly.
              </p>

              <h2 className="fw-bold mt-5 mb-3">
                Benefits of Using Age Calculator
              </h2>

              <ul>

                <li>
                  Instant age calculation
                </li>

                <li>
                  Accurate results
                </li>

                <li>
                  Birthday countdown
                </li>

                <li>
                  Mobile responsive
                </li>

                <li>
                  Free online tool
                </li>

              </ul>

              <h2 className="fw-bold mt-5 mb-3">
                Frequently Asked Questions
              </h2>

              <div className="mb-4">

                <h5>
                  Is this age calculator accurate?
                </h5>

                <p>
                  Yes, it calculates exact
                  age based on your date
                  of birth.
                </p>

              </div>

              <div className="mb-4">

                <h5>
                  Can I calculate age in days?
                </h5>

                <p>
                  Yes, this calculator shows
                  total days, weeks, and hours.
                </p>

              </div>

              <div className="mb-4">

                <h5>
                  Is this tool free?
                </h5>

                <p>
                  Yes, this online age
                  calculator is completely free.
                </p>

              </div>

              {/* RELATED TOOLS */}

              <div className="mt-5 p-4 bg-light rounded-4">

                <h3 className="fw-bold mb-3">
                  Related Tools
                </h3>

                <div className="d-flex flex-wrap gap-3">

                  <a
                    href="/bmi-calculator"
                    className="btn btn-outline-primary"
                  >
                    BMI Calculator
                  </a>

                  <a
                    href="/percentage-calculator"
                    className="btn btn-outline-primary"
                  >
                    Percentage Calculator
                  </a>

                  <a
                    href="/emi-calculator"
                    className="btn btn-outline-primary"
                  >
                    EMI Calculator
                  </a>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

      <Footer />

    </>
  );
}